import React, { useState } from "react";
import IDialog from "./IDialog";
import { AiOutlineExclamationCircle, AiOutlineClose } from "react-icons/ai";

function ContactFormDialog({
  message,
  cancelLabel = "",
  confirmLabel,
  instructions,
  instructionsListStyle = "ordered",
  onClose = () => {},
  onCloseDefault = () => {},
  onCancel = () => {},
  onConfirm = () => {},
  onUserMessageChange,
}: IDialog) {
  const [userMessage, setUserMessage] = useState("");

  const handleUserMessageChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setUserMessage(e.target.value);
    onUserMessageChange?.(e.target.value);
  };

  const displayMessage = message?.split("\n").map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ));

  const displayInstructions = instructions?.map((instruction, index) => (
    <li key={index}>{instruction}</li>
  ));

  return (
    <div
      tabIndex={-1}
      className="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full h-[calc(100%-0rem)] max-h-full bg-gray-950 bg-opacity-35"
    >
      <div className="relative p-4 w-full max-w-2xl max-h-full">
        <div className="relative bg-white rounded-lg shadow">
          <button
            type="button"
            className="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
            onClick={() => {
              onCloseDefault();
              onClose();
            }}
          >
            <AiOutlineClose className="w-3 h-3" />
          </button>

          <div className="p-4 md:p-5 text-center">
            <AiOutlineExclamationCircle className="mx-auto mb-4 text-gray-400 w-12 h-12" />
            <h3 className="text-lg font-normal text-gray-500 my-8 mb-12">
              <div className="text-justify">{displayMessage}</div>
              {instructionsListStyle === "ordered" && (
                <ol className="text-justify mt-4 pl-7 list-decimal">
                  {displayInstructions}
                </ol>
              )}
              {instructionsListStyle === "unordered" && (
                <ul className="text-justify mt-4 pl-7 list-disc">
                  {displayInstructions}
                </ul>
              )}
            </h3>
            <textarea
              className="w-full mt-2 mb-6 p-3 text-sm text-gray-700 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300 resize-none"
              rows={4}
              placeholder="Leave a message to motivate your request..."
              value={userMessage}
              onChange={handleUserMessageChange}
            />
            {cancelLabel && (
              <button
                type="button"
                className="py-2.5 px-5 mr-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100"
                onClick={() => {
                  onCloseDefault();
                  onClose();
                  onCancel();
                }}
              >
                {cancelLabel}
              </button>
            )}
            <button
              type="button"
              className="text-white bg-green-600 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center"
              onClick={() => {
                onCloseDefault();
                onClose();
                onConfirm();
              }}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactFormDialog;
